import { useSelector } from 'react-redux';

const useAuth = () => {
	const activeUser = useSelector((state) => state.activeAccount);
	return activeUser;
};

export default useAuth;
